import { useMemo } from 'react';
import jwt_decode from 'jwt-decode';
import useAuth from '@HOOKS/useAuth';
import userRepository from '@REPOSITORIES/local-repository/user-repository';
import { JwtPayload } from '@REDUCERS';

export default function useSuperAdminPermissions() {
    const { state: { user } } = useAuth();

    return useMemo(() => {
        // If no user, definitely not a super admin
        if (!user) return false;

        // Check the JWT token for is_super_admin flag
        const token = userRepository.getData();
        if (!token) return false;

        try {
            const decoded: JwtPayload = jwt_decode(token);
            return decoded.is_super_admin || false;
        } catch (error) {
            console.error('Error decoding token:', error);
            return false;
        }
    }, [user]);
} 